(function () {
  if (window.__offhooCollectionJsBound) return;
  window.__offhooCollectionJsBound = true;

  var activeAbortController = null;
  var infiniteScrollCleanups = new WeakMap();
  var drawerLastTrigger = null;

  function getFocusable(container) {
    return Array.from(
      container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (element) {
      return element.offsetParent !== null;
    });
  }

  function getCollectionRoot(fromEl) {
    return fromEl && fromEl.closest ? fromEl.closest('[data-offhoo-collection]') : null;
  }

  function getActiveCollectionRoot() {
    return document.querySelector('[data-offhoo-collection]');
  }

  function getSectionId(root) {
    if (!root) return '';
    if (root.dataset.sectionId) return root.dataset.sectionId;

    var sectionEl = root.closest('[id^="shopify-section-"]');
    if (!sectionEl || !sectionEl.id) return '';
    return sectionEl.id.replace(/^shopify-section-/, '');
  }

  function getShopifySectionEl(sectionId, root) {
    if (sectionId) {
      var byId = document.getElementById('shopify-section-' + sectionId);
      if (byId) return byId;
    }
    return root ? root.closest('[id^="shopify-section-"]') : null;
  }

  function findIncomingSection(doc, sectionId) {
    if (!doc) return null;
    if (sectionId) {
      var byId = doc.getElementById('shopify-section-' + sectionId);
      if (byId) return byId;
    }
    return doc.querySelector('[id^="shopify-section-"]');
  }

  function stripScripts(node) {
    if (!node || !node.querySelectorAll) return node;
    node.querySelectorAll('script').forEach(function (script) {
      script.remove();
    });
    return node;
  }

  function normalizePathname(pathname) {
    if (!pathname || pathname === '/') return pathname || '/';
    return pathname.replace(/\/+$/, '') || '/';
  }

  function normalizeUrl(pageUrl) {
    var url = new URL(pageUrl.toString(), window.location.origin);
    url.pathname = normalizePathname(url.pathname);
    return url;
  }

  function getCheckedOfertaFilter(root) {
    var scope = root || document;
    return scope.querySelector('[data-offhoo-tag-filter]:checked');
  }

  /**
   * Oferta uses collection tag paths (not form fields). Keep pathname in sync
   * with the checkbox so price/sort requests cannot drop the tag filter.
   */
  function syncOfertaPathname(url, root) {
    var checked = getCheckedOfertaFilter(root);
    if (checked && checked.dataset.urlOn) {
      url.pathname = normalizePathname(new URL(checked.dataset.urlOn, window.location.origin).pathname);
      return url;
    }

    var any = (root || document).querySelector('[data-offhoo-tag-filter]');
    if (any && any.dataset.urlOn && any.dataset.urlOff) {
      var onPath = normalizePathname(new URL(any.dataset.urlOn, window.location.origin).pathname);
      var offPath = normalizePathname(new URL(any.dataset.urlOff, window.location.origin).pathname);
      if (normalizePathname(url.pathname) === onPath) {
        url.pathname = offPath;
      }
    }

    return url;
  }

  /**
   * Read active sort/filter query from the live forms (price lives here).
   */
  function collectFilterQueryFromRoot(root) {
    var params = new URLSearchParams();
    if (!root) return params;

    var forms = root.querySelectorAll('.offhoo-collection-filters, [data-offhoo-sort-form]');
    forms.forEach(function (form) {
      var formData = new FormData(form);
      formData.forEach(function (value, key) {
        if (value === null || value === undefined || value === '') return;
        if (key !== 'sort_by' && key.indexOf('filter.') !== 0) return;
        if (key === 'sort_by') {
          params.set(key, String(value));
          return;
        }
        if (!params.getAll(key).includes(String(value))) {
          params.append(key, String(value));
        }
      });
    });

    return params;
  }

  function buildSectionRenderUrl(pageUrl, sectionId) {
    var url = normalizeUrl(pageUrl);
    url.searchParams.delete('page');
    url.searchParams.set('section_id', sectionId);
    return url;
  }

  function buildPublicUrl(pageUrl) {
    var url = normalizeUrl(pageUrl);
    url.searchParams.delete('section_id');
    url.searchParams.delete('page');
    return url;
  }

  function urlFromForm(form, root) {
    root = root || getCollectionRoot(form);
    var action = form.getAttribute('action') || window.location.pathname;
    var url = normalizeUrl(new URL(action, window.location.origin));
    var params = new URLSearchParams();
    var formData = new FormData(form);

    formData.forEach(function (value, key) {
      if (value === null || value === undefined) return;
      params.append(key, String(value));
    });

    url.search = params.toString();
    syncOfertaPathname(url, root);
    return url;
  }

  function setLoading(root, isLoading) {
    if (!root) return;
    root.classList.toggle('is-loading', Boolean(isLoading));
    root.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  function unlockPageScroll() {
    document.documentElement.classList.remove('offhoo-filter-drawer-open');
  }

  function closeDrawer(root) {
    var drawer = root && root.querySelector('[data-offhoo-filter-drawer]');
    if (drawer) {
      drawer.hidden = true;
      drawer.setAttribute('aria-hidden', 'true');
    }
    unlockPageScroll();

    if (drawerLastTrigger && typeof drawerLastTrigger.focus === 'function') {
      drawerLastTrigger.focus();
      drawerLastTrigger = null;
    }
  }

  function openDrawer(root) {
    var drawer = root && root.querySelector('[data-offhoo-filter-drawer]');
    if (!drawer) return;

    drawerLastTrigger = document.activeElement;
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('offhoo-filter-drawer-open');

    var focusable = getFocusable(drawer);
    if (focusable.length > 0) {
      focusable[0].focus();
    }
  }

  function cleanupInfiniteScroll(root) {
    var cleanup = infiniteScrollCleanups.get(root);
    if (typeof cleanup === 'function') {
      cleanup();
      infiniteScrollCleanups.delete(root);
    }
  }

  function removePriceInputs(form) {
    form.querySelectorAll('[data-offhoo-price-value]').forEach(function (input) {
      input.remove();
    });
  }

  function addPriceInput(form, name, value, bound) {
    if (!name || value === undefined || value === null || value === '') return;

    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    input.dataset.offhooPriceValue = 'true';
    input.dataset.offhooPriceBound = bound;
    form.appendChild(input);
  }

  function fetchAndReplace(root, pageUrl, options) {
    options = options || {};
    var shouldCloseDrawer = options.closeDrawer !== false;
    var shouldPushState = options.pushState === true;
    root = root || getActiveCollectionRoot();
    var sectionId = getSectionId(root);

    if (!root || !sectionId) {
      console.warn('[offhoo-collection] Missing collection root or section id');
      unlockPageScroll();
      return Promise.resolve();
    }

    var publicUrl = buildPublicUrl(pageUrl);
    var renderUrl = buildSectionRenderUrl(publicUrl, sectionId);

    if (activeAbortController) {
      activeAbortController.abort();
    }

    activeAbortController = new AbortController();
    var signal = activeAbortController.signal;

    setLoading(root, true);

    return fetch(renderUrl.toString(), {
      credentials: 'same-origin',
      signal: signal,
      headers: {
        Accept: 'text/html',
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then(function (response) {
        if (!response.ok) {
          var httpError = new Error('http-' + response.status);
          httpError.code = 'http';
          throw httpError;
        }
        return response.text();
      })
      .then(function (html) {
        if (signal.aborted) return;

        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incomingSection = findIncomingSection(doc, sectionId);
        var incomingRoot = doc.querySelector('[data-offhoo-collection]');
        // Always re-query live section — do not reuse a stale node from request start.
        var sectionEl = getShopifySectionEl(sectionId, getActiveCollectionRoot());

        if (!sectionEl || (!incomingSection && !incomingRoot)) {
          var missingError = new Error('missing-section');
          missingError.code = 'missing-section';
          throw missingError;
        }

        var liveRoot = sectionEl.querySelector('[data-offhoo-collection]') || getActiveCollectionRoot();
        if (liveRoot) {
          cleanupInfiniteScroll(liveRoot);
        }
        unlockPageScroll();

        try {
          if (incomingSection) {
            var nextSection = stripScripts(document.importNode(incomingSection, true));
            sectionEl.replaceWith(nextSection);
          } else {
            var currentRoot = sectionEl.querySelector('[data-offhoo-collection]');
            var nextRootNode = stripScripts(document.importNode(incomingRoot, true));
            if (currentRoot) {
              currentRoot.replaceWith(nextRootNode);
            } else {
              sectionEl.replaceChildren(nextRootNode);
            }
          }
        } catch (replaceError) {
          replaceError.code = 'replace';
          throw replaceError;
        }

        if (shouldPushState) {
          history.pushState({ offhooCollection: true }, '', publicUrl.toString());
        }

        var replacedSection = getShopifySectionEl(sectionId, null) || sectionEl;
        var nextRoot =
          (replacedSection && replacedSection.querySelector('[data-offhoo-collection]')) ||
          getActiveCollectionRoot();

        if (shouldCloseDrawer && nextRoot) {
          closeDrawer(nextRoot);
        }

        try {
          initCollectionUi(nextRoot);
        } catch (initError) {
          console.warn('[offhoo-collection] init after replace failed', initError);
        }

        // Keep document title in sync when switching collections via chips.
        var nextTitle = doc.querySelector('title');
        var nextHeading = nextRoot && nextRoot.querySelector('.offhoo-main-collection__header h1');
        if (nextTitle && nextTitle.textContent) {
          document.title = nextTitle.textContent;
        } else if (nextHeading && nextHeading.textContent) {
          document.title = nextHeading.textContent.trim();
        }
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;

        var liveRoot = getActiveCollectionRoot() || root;
        setLoading(liveRoot, false);
        unlockPageScroll();
        console.warn('[offhoo-collection] async update failed', error);

        // Category navigation is a real destination — fall back to full load on failure.
        if (shouldPushState) {
          window.location.href = publicUrl.toString();
        }
      })
      .finally(function () {
        if (activeAbortController && activeAbortController.signal === signal) {
          activeAbortController = null;
        }
      });
  }

  function navigatePreservingQuery(root, pathname, options) {
    var next = normalizeUrl(window.location.origin + pathname);
    next.pathname = normalizePathname(pathname);

    // Keep price/sort from forms — address bar may be stale (we don't pushState).
    var merged = collectFilterQueryFromRoot(root);
    var locationParams = new URLSearchParams(window.location.search);
    locationParams.forEach(function (value, key) {
      if (key === 'section_id' || key === 'page' || key === 'filter.p.tag') return;
      if (key === 'sort_by' || key.indexOf('filter.') === 0) {
        if (!merged.has(key)) merged.set(key, value);
        return;
      }
      if (!merged.has(key)) merged.set(key, value);
    });

    next.search = merged.toString();
    next.searchParams.delete('filter.p.tag');
    next.searchParams.delete('page');
    next.searchParams.delete('section_id');

    return fetchAndReplace(root, next, options);
  }

  function handleLegacyTagRedirect(root) {
    if (!root) return;

    root.querySelectorAll('[data-offhoo-tag-filter]').forEach(function (checkbox) {
      var legacyTag = new URLSearchParams(window.location.search).get('filter.p.tag');
      if (legacyTag && legacyTag === checkbox.dataset.tag && !checkbox.checked && checkbox.dataset.urlOn) {
        navigatePreservingQuery(root, new URL(checkbox.dataset.urlOn, window.location.origin).pathname, {
          closeDrawer: true,
        });
      }
    });
  }

  function initCollectionUi(root) {
    if (!root) return;
    cleanupInfiniteScroll(root);
    initInfiniteScroll(root);
    handleLegacyTagRedirect(root);
  }

  function bindDelegatedEvents() {
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.matches('[data-offhoo-sort-form], .offhoo-collection-filters')) return;

      var root = getCollectionRoot(form);
      if (!root) return;

      event.preventDefault();
      fetchAndReplace(root, urlFromForm(form, root), { closeDrawer: true });
    });

    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!(target instanceof HTMLElement)) return;

      var root = getCollectionRoot(target);
      if (!root) return;

      if (target.matches('[data-offhoo-sort-form] select')) {
        if (!target.form) return;
        fetchAndReplace(root, urlFromForm(target.form, root), { closeDrawer: false });
        return;
      }

      if (target.matches('[data-offhoo-price-range]')) {
        var priceForm = target.form;
        if (!priceForm) return;

        priceForm.querySelectorAll('[data-offhoo-price-range]').forEach(function (rangeInput) {
          if (rangeInput !== target) {
            rangeInput.checked = false;
          }
        });

        removePriceInputs(priceForm);

        if (target.checked) {
          addPriceInput(priceForm, target.dataset.priceMinName, target.dataset.priceMin, 'min');
          addPriceInput(priceForm, target.dataset.priceMaxName, target.dataset.priceMax, 'max');
        }

        // Keep Oferta tag path even when form.action is still the untagged collection URL.
        fetchAndReplace(root, urlFromForm(priceForm, root), { closeDrawer: true });
        return;
      }

      if (target.matches('[data-offhoo-filter-auto-submit]')) {
        if (!target.form) return;
        fetchAndReplace(root, urlFromForm(target.form, root), { closeDrawer: true });
        return;
      }

      if (target.matches('[data-offhoo-tag-filter]')) {
        var tagTarget = target.checked ? target.dataset.urlOn : target.dataset.urlOff;
        if (!tagTarget) return;
        navigatePreservingQuery(root, new URL(tagTarget, window.location.origin).pathname, {
          closeDrawer: true,
        });
      }
    });

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;

      var chip = target.closest('a.offhoo-subcategory-chip');
      if (chip) {
        var chipRoot = getCollectionRoot(chip);
        if (!chipRoot) return;

        var chipUrl = normalizeUrl(chip.href);
        if (chipUrl.origin !== window.location.origin) return;
        if (chipUrl.pathname.indexOf('/collections/') === -1) return;

        event.preventDefault();

        // Already on this collection chip — no-op.
        if (
          chip.classList.contains('offhoo-subcategory-chip--active') &&
          normalizePathname(chipUrl.pathname) === normalizePathname(window.location.pathname)
        ) {
          return;
        }

        // Switch collection without carrying previous collection filters.
        chipUrl.searchParams.delete('section_id');
        chipUrl.searchParams.delete('page');
        fetchAndReplace(chipRoot, chipUrl, { closeDrawer: true, pushState: true });
        return;
      }

      var openButton = target.closest('[data-offhoo-filter-open]');
      if (openButton) {
        var openRoot = getCollectionRoot(openButton);
        if (!openRoot) return;
        event.preventDefault();
        openDrawer(openRoot);
        return;
      }

      var closeButton = target.closest('[data-offhoo-filter-close]');
      if (closeButton) {
        var closeRoot = getCollectionRoot(closeButton);
        if (!closeRoot) return;
        event.preventDefault();
        closeDrawer(closeRoot);
        return;
      }

      var preserveLink = target.closest('[data-offhoo-preserve-query]');
      if (preserveLink && preserveLink.tagName === 'A') {
        var preserveRoot = getCollectionRoot(preserveLink);
        if (!preserveRoot) return;
        event.preventDefault();
        navigatePreservingQuery(preserveRoot, new URL(preserveLink.href, window.location.origin).pathname, {
          closeDrawer: true,
        });
        return;
      }

      var activeFilterLink = target.closest('a.offhoo-active-filter');
      if (activeFilterLink) {
        var activeRoot = getCollectionRoot(activeFilterLink);
        if (!activeRoot) return;
        event.preventDefault();
        fetchAndReplace(activeRoot, new URL(activeFilterLink.href, window.location.origin), {
          closeDrawer: true,
        });
        return;
      }

      var priceClear = target.closest('[data-offhoo-price-clear]');
      if (priceClear) {
        var clearRoot = getCollectionRoot(priceClear);
        var clearForm = priceClear.form || (priceClear.closest && priceClear.closest('form'));
        if (!clearRoot || !clearForm) return;
        event.preventDefault();

        clearForm.querySelectorAll('[data-offhoo-price-range]').forEach(function (checkbox) {
          checkbox.checked = false;
        });
        removePriceInputs(clearForm);
        fetchAndReplace(clearRoot, urlFromForm(clearForm, clearRoot), { closeDrawer: true });
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' && event.key !== 'Tab') return;

      var root = getActiveCollectionRoot();
      if (!root) return;

      var drawer = root.querySelector('[data-offhoo-filter-drawer]');
      if (!drawer || drawer.hidden) return;

      if (event.key === 'Escape') {
        closeDrawer(root);
        return;
      }

      if (event.key !== 'Tab') return;

      var focusable = getFocusable(drawer);
      if (focusable.length === 0) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    document.addEventListener('click', function (event) {
      var root = getActiveCollectionRoot();
      if (!root) return;
      var drawer = root.querySelector('[data-offhoo-filter-drawer]');
      if (drawer && event.target === drawer) {
        closeDrawer(root);
      }
    });
  }

  function getProductKey(item) {
    if (item.dataset.offhooProductId) {
      return 'id:' + item.dataset.offhooProductId;
    }

    var link = item.querySelector('a[href*="/products/"]');
    if (link) {
      return 'url:' + link.getAttribute('href');
    }

    return '';
  }

  function getScrollRoot() {
    var pageWrapper = document.querySelector('.page-wrapper');

    if (pageWrapper) {
      var wrapperStyle = window.getComputedStyle(pageWrapper);
      if (wrapperStyle.overflowY === 'auto' || wrapperStyle.overflowY === 'scroll') {
        return pageWrapper;
      }
    }

    return document.scrollingElement || document.documentElement;
  }

  function getDistanceFromBottom(scrollRoot) {
    if (scrollRoot === document.documentElement || scrollRoot === document.body) {
      var doc = document.documentElement;
      return doc.scrollHeight - (window.scrollY || doc.scrollTop) - window.innerHeight;
    }

    return scrollRoot.scrollHeight - scrollRoot.scrollTop - scrollRoot.clientHeight;
  }

  function initInfiniteScroll(root) {
    cleanupInfiniteScroll(root);

    var grid = root.querySelector('[data-offhoo-product-grid]');
    var sentinel = root.querySelector('[data-offhoo-infinite-scroll]');
    var status = sentinel ? sentinel.querySelector('[data-offhoo-infinite-scroll-status]') : null;

    if (!grid || !sentinel) return;

    var loading = false;
    var finished = !sentinel.dataset.nextUrl;
    var offset = Number(sentinel.dataset.offset || 400);
    if (!Number.isFinite(offset) || offset < 0) {
      offset = 400;
    }

    var loadingLabel = sentinel.dataset.loadingLabel || 'Cargando...';
    var errorLabel = sentinel.dataset.errorLabel || 'No se pudieron cargar más productos';
    var endLabel = sentinel.dataset.endLabel || 'No hay más productos';
    var scrollRoot = getScrollRoot();
    var ticking = false;
    var pageAbort = null;

    function setStatus(text) {
      if (status) {
        status.textContent = text || '';
      }
    }

    function markFinished() {
      finished = true;
      sentinel.dataset.nextUrl = '';
      sentinel.dataset.loading = 'false';
      setStatus(endLabel);
    }

    function loadNextPage() {
      var nextUrl = sentinel.dataset.nextUrl;

      if (!nextUrl || loading || finished) return;
      // Skip if this collection root was replaced.
      if (!root.isConnected) return;

      loading = true;
      sentinel.dataset.loading = 'true';
      setStatus(loadingLabel);

      if (pageAbort) {
        pageAbort.abort();
      }
      pageAbort = new AbortController();

      fetch(nextUrl, {
        credentials: 'same-origin',
        signal: pageAbort.signal,
        headers: {
          Accept: 'text/html',
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error(response.status);
          }

          return response.text();
        })
        .then(function (html) {
          if (!root.isConnected || !grid.isConnected) return;

          var doc = new DOMParser().parseFromString(html, 'text/html');
          var incomingGrid = doc.querySelector('[data-offhoo-product-grid]');
          var incomingItems = incomingGrid
            ? Array.from(incomingGrid.querySelectorAll('[data-offhoo-product-item]'))
            : [];
          var existingKeys = new Set(
            Array.from(grid.querySelectorAll('[data-offhoo-product-item]'))
              .map(getProductKey)
              .filter(Boolean)
          );

          incomingItems.forEach(function (item) {
            var key = getProductKey(item);

            if (key && existingKeys.has(key)) return;
            if (key) {
              existingKeys.add(key);
            }

            grid.appendChild(document.importNode(item, true));
          });

          var nextSentinel = doc.querySelector('[data-offhoo-infinite-scroll]');
          var nextUrlFromPage = nextSentinel && nextSentinel.dataset.nextUrl;

          loading = false;
          sentinel.dataset.loading = 'false';

          if (nextUrlFromPage) {
            sentinel.dataset.nextUrl = nextUrlFromPage;
            setStatus('');
            maybeLoad();
            return;
          }

          markFinished();
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          loading = false;
          if (sentinel.isConnected) {
            sentinel.dataset.loading = 'false';
          }
          setStatus(errorLabel);
        });
    }

    function maybeLoad() {
      if (!root.isConnected || loading || finished || !sentinel.dataset.nextUrl) return;

      if (getDistanceFromBottom(scrollRoot) <= offset) {
        loadNextPage();
      }
    }

    function requestCheck() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        maybeLoad();
      });
    }

    window.addEventListener('scroll', requestCheck, { passive: true });
    window.addEventListener('resize', requestCheck);

    if (scrollRoot !== document.documentElement && scrollRoot !== document.body) {
      scrollRoot.addEventListener('scroll', requestCheck, { passive: true });
    }

    infiniteScrollCleanups.set(root, function () {
      window.removeEventListener('scroll', requestCheck);
      window.removeEventListener('resize', requestCheck);
      if (scrollRoot !== document.documentElement && scrollRoot !== document.body) {
        scrollRoot.removeEventListener('scroll', requestCheck);
      }
      if (pageAbort) {
        pageAbort.abort();
      }
    });

    maybeLoad();
  }

  function initAll(context) {
    (context || document).querySelectorAll('[data-offhoo-collection]').forEach(initCollectionUi);
  }

  function flushEarlyQueue() {
    var boot = window.__offhooCollectionEarly;
    if (!boot) return;

    boot.active = false;
    var queue = boot.queue.splice(0);
    if (!queue.length) return;

    queue.forEach(function (item) {
      if (!item || !item.target || !item.target.isConnected) return;

      try {
        if (item.type === 'change') {
          item.target.dispatchEvent(new Event('change', { bubbles: true }));
        } else if (item.type === 'click') {
          item.target.dispatchEvent(
            new MouseEvent('click', { bubbles: true, cancelable: true, view: window })
          );
        } else if (item.type === 'submit') {
          item.target.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      } catch (error) {
        console.warn('[offhoo-collection] early queue replay failed', error);
      }
    });
  }

  // Stop early capture first, then bind real handlers, then replay queued clicks.
  if (window.__offhooCollectionEarly) {
    window.__offhooCollectionEarly.active = false;
  }

  bindDelegatedEvents();
  flushEarlyQueue();

  // Category chip async navigation uses pushState — support browser back/forward.
  window.addEventListener('popstate', function () {
    var root = getActiveCollectionRoot();
    if (!root) return;
    fetchAndReplace(root, new URL(window.location.href), { closeDrawer: true, pushState: false });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
